import { useEffect, useState } from 'react';

/**
 * Henter build-tidspunkt fra /version.json (generert ved build) og returnerer
 * en formatert norsk dato+tid-streng. Tom streng hvis ikke tilgjengelig
 * (f.eks. i lokal dev-modus uten version.json).
 */
export function usePublishedDate(): string {
  const [publishedDate, setPublishedDate] = useState<string>('');

  useEffect(() => {
    fetch('/version.json?t=' + Date.now())
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (data?.buildTime) {
          const d = new Date(data.buildTime);
          setPublishedDate(
            d.toLocaleDateString('no-NO') + ' ' +
            d.toLocaleTimeString('no-NO', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
          );
        }
      })
      .catch(() => setPublishedDate('Ukjent'));
  }, []);

  return publishedDate;
}
